import * as React from "react";
import {
    CommandBarButton
} from "office-ui-fabric-react";
import CreateSiteForm, { CreateSiteFormUser } from "../../models/CreateSiteForm";
import { connect } from "react-redux";
import { IRootState } from "../../store";
import BaseCreateSitePage from "./BaseCreateSitePage";
import ApiService from "../ApiService";
import DispatchProps from "../../utils/DispatchProps";
import * as H from "history";
import CreateTeamSiteCard from "../CreateTeamSiteCard";
import { Fragment } from "react";
import School from "../../models/School";
import ListCreateSiteForms from "../ListCreateSiteForms";
import { AccountInfo } from "@azure/msal-browser";
import LoadingPage from "../LoadingPage";
import {MegaMenuOptions} from "../MegaMenuItemSelector";
import SchoolMenu from "../SchoolMenu";
import SchoolPageTitle from "../SchoolPageTitle";

interface CreateTeamSitePageProps {
    tenantId: string;
    schoolCode: string;
    history: H.History;
    apiService: ApiService;

    currentLoggedInUser: AccountInfo;
}

interface CreateTeamSitePageState {
    loading: boolean;
    
    school?: School;
    megaMenuOptions?: MegaMenuOptions;
    saveButtonDisabled: boolean;
    form?: CreateSiteForm;
}

class CreateTeamSitePage extends BaseCreateSitePage<CreateTeamSitePageProps & DispatchProps, CreateTeamSitePageState>
{
    constructor(props: CreateTeamSitePageProps & DispatchProps) {
        super(props);

        this.state = {
            loading: true,
            saveButtonDisabled: false,
            form: undefined
        }
    }

    public async componentDidMount(): Promise<void> {

        this.setState({
            loading: true
        });

        const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)
        const megaMenuOptions = await this.props.apiService.getMegaMenuOptions(this.props.tenantId,this.props.schoolCode)
        const form = new CreateSiteForm("teams");

        const convertedUser: CreateSiteFormUser = {
            userId: this.props.currentLoggedInUser.localAccountId,
            userDisplayName: this.props.currentLoggedInUser.name!,
            userPrincipalName: this.props.currentLoggedInUser.username,
            createSiteFormId: form.id,
            access: "owner"
        }
        form.users.push(convertedUser);

        CreateSiteForm.setDefaultMegaMenuOptionIfExists(form,megaMenuOptions);
        
        this.setState({
            loading: false,
            school,
            form,
            megaMenuOptions
        });
    }

    public async componentDidUpdate(prevProps: Readonly<CreateTeamSitePageProps & DispatchProps>, prevState: Readonly<CreateTeamSitePageState>, snapshot?: any): Promise<void> {
    }

    private renderContent() {
        if (this.state.loading || this.state.form === undefined) {
            return <LoadingPage />;
        }
        else {
            return <Fragment>
                <div className={"flex-row"}>
                    <CreateTeamSiteCard tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} disabled={false} form={this.state.form!} megaMenuOptions={this.state.megaMenuOptions!}>
                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            disabled={this.state.saveButtonDisabled}
                            onClick={this.submitForm}
                        />
                    </CreateTeamSiteCard>
                </div>
                <ListCreateSiteForms tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} siteType={"teams"} />
            </Fragment>
        }
    }

    public render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Site Creation (Team Site)" reverse={true} />
                <SchoolMenu prefix="Create Site" prefixLink={`/manage/${this.props.tenantId}/${this.props.schoolCode}/create-site`} suffix="Team Site" />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    {this.renderContent()}
                </div>
            </Fragment>
        );
    }
}

export default connect((state: IRootState, ownProps: { history: H.History, match: any }): CreateTeamSitePageProps => {
    return {
        tenantId: ownProps.match.params.tenantId,
        schoolCode: ownProps.match.params.schoolCode,
        history: ownProps.history,
        apiService: state.auth.apiService,
        currentLoggedInUser: state.auth.user!
    }
})(CreateTeamSitePage);